import {
  getEntitiesByKeyList,
  getCascadingFields,
} from "@shared/components/form-builder/utils";

const findRelatedFields = (formField, restForms) => {
  const relatedFields = [];

  restForms.forEach((form) => {
    form?.form_data.sections.forEach((section) => {
      const relatedFieldsMatches = getEntitiesByKeyList(section?.entities, {
        field_id: formField.field_id,
        field_fe_id: formField.field_fe_id,
      });
      relatedFields.push(...relatedFieldsMatches);
    });
  });

  return relatedFields;
}

const organizeSectionCompareList = (list, restForms) => {
  return list.map((formEntity) => {
    if (formEntity.entities) {
      return {
        ...formEntity,
        entities: organizeSectionCompareList(formEntity.entities, restForms),
      }
    } else if (formEntity.form_entity_type === "FIELD") {
      const relatedFields = findRelatedFields(formEntity, restForms);

      const hasDifferentValues = relatedFields.some((field) => {
        return field.value !== formEntity.value;
      });

      const result = {
        ...formEntity,
        highlight: hasDifferentValues,
      };

      const cascadingFields = getCascadingFields(formEntity);
      if (cascadingFields) {
        result.options = result.options.map((option) => {
          return {
            ...option,
            cascading_fields: organizeSectionCompareList(option.cascading_fields, restForms),
          }
        })
      }

      return result;
    }
  });
}

/**
 * Organizes the comparison data by extracting relevant fields.
 * Checks if related fields have different values.
 * @param {Array} formList List of section lists
 */
export const organizeComparisonData = (formList) => {

  const result = formList.map((formItem) => {
    const restLists = formList.filter((item) => item.id !== formItem.id);

    return {
      ...formItem,
      form_data: {
        ...formItem.form_data,
        sections: formItem.form_data.sections.map((section) => {
          return {
            ...section,
            entities: organizeSectionCompareList(section.entities, restLists),
          };
        }),
      },
    };
  });

  return result;
}